const SMARTCAPTCHA_SCRIPT_ID = 'yandex-smartcaptcha-script';
const SMARTCAPTCHA_SCRIPT_SRC = 'https://smartcaptcha.cloud.yandex.ru/captcha.js';

let scriptLoadPromise = null;

const waitForSmartCaptchaApi = (resolve, reject, attempts = 0) => {
    if (window.smartCaptcha) {
        resolve();
        return;
    }
    if (attempts >= 50) {
        reject(new Error('SmartCaptcha API not available'));
        return;
    }
    setTimeout(() => waitForSmartCaptchaApi(resolve, reject, attempts + 1), 50);
};

export const loadSmartCaptchaScript = () => {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Window is not available'));
    }
    if (window.smartCaptcha) {
        return Promise.resolve();
    }
    if (scriptLoadPromise) {
        return scriptLoadPromise;
    }

    scriptLoadPromise = new Promise((resolve, reject) => {
        const finish = () => waitForSmartCaptchaApi(resolve, reject);

        const existing = document.getElementById(SMARTCAPTCHA_SCRIPT_ID);
        if (existing) {
            if (existing.getAttribute('data-loaded') === 'true') {
                finish();
                return;
            }
            existing.addEventListener('load', finish, { once: true });
            existing.addEventListener('error', () => reject(new Error('Failed to load captcha')), { once: true });
            return;
        }

        const script = document.createElement('script');
        script.id = SMARTCAPTCHA_SCRIPT_ID;
        script.src = SMARTCAPTCHA_SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            script.setAttribute('data-loaded', 'true');
            finish();
        };
        script.onerror = () => reject(new Error('Failed to load captcha'));
        document.head.appendChild(script);
    });

    return scriptLoadPromise;
};

export const decodeJwtPayload = (token) => {
    if (!token) return null;
    try {
        const payload = token.split('.')[1];
        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = atob(normalized);
        return JSON.parse(decoded);
    } catch {
        return null;
    }
};

export const getTokenAuthType = (token) => {
    const payload = decodeJwtPayload(token);
    if (!payload) return null;
    if (payload.auth_type) return payload.auth_type;
    if (String(payload.sub || '').startsWith('cred:')) return 'credential';
    return 'user';
};

export const isTelegramLinkedToken = (token) => getTokenAuthType(token) === 'user';
